export enum DialogTypes {
  SUCCESS = 'success',
  ERROR = 'error',
}
